(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("moment"), require("hot-formula-parser"), require("pikaday"), require("numbro"));
	else if(typeof define === 'function' && define.amd)
		define("Handsontable", ["moment", "hot-formula-parser", "pikaday", "numbro"], factory);
	else if(typeof exports === 'object')
		exports["Handsontable"] = factory(require("moment"), require("hot-formula-parser"), require("pikaday"), require("numbro"));
	else
		root["Handsontable"] = factory(root["moment"], root["formulaParser"], root["Pikaday"], root["numbro"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__70__, __WEBPACK_EXTERNAL_MODULE__117__, __WEBPACK_EXTERNAL_MODULE__325__, __WEBPACK_EXTERNAL_MODULE__336__) {
return 